import React from 'react';
import PropTypes from 'prop-types';
import { Label, Input } from 'rebass';

const FilterText = ({ label, value, onChange, placeholder }) => (
  <Label>
    {label}
    <Input
      bg="white"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </Label>
);
FilterText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};
export default FilterText;



// WEBPACK FOOTER //
// ./src/components/molecules/FilterText/index.js